import { useQuery } from '@tanstack/react-query';

import { getSearchProjectSubcontractSelectOptions } from './projectSubcontracts';
import { TypesenseCollection } from '../types';
import { useGetTypeSenseAPIKeys } from '@/api/REST/typeSenseAPIKeys';

const PROJECT_SUBCONTRACTS_OPTION_KEY = 'projectSubcontractOption';
export const useGetDefaultProjectSubcontractOptionByProjectId = (
  projectId: number | string | undefined,
) => {
  const _projectId =
    projectId && typeof projectId === 'string'
      ? projectId
      : (projectId?.toString() ?? undefined);

  const { data: apiKeys } = useGetTypeSenseAPIKeys();
  const collectionApiKey =
    apiKeys?.[TypesenseCollection.PROJECT_SUBCONTRACTS.keyName]?.key ?? null;

  const filter = `ProjectId:=${_projectId} && IsDefaultExpenses:true`;

  const { data, ...restProps } = useQuery({
    queryKey: [PROJECT_SUBCONTRACTS_OPTION_KEY, filter, collectionApiKey],
    queryFn: () =>
      getSearchProjectSubcontractSelectOptions('*', collectionApiKey!, 1, {
        filterBy: filter,
      }),
    enabled: !!_projectId && !!collectionApiKey,
  });

  return { data: data ? data[0] : undefined, ...restProps };
};
